import React from 'react'
import { Separator, Paragraph, H2, H3 } from '@fs/zion-ui'
import { Link } from '@fs/zion-router'
import { useTranslation } from 'react-i18next'

export default function DesktopPushNotificationInstructions() {
  const { t } = useTranslation()
  return (
    <>
      <Separator size="lg" />
      <H2 size="H5">{t('invitations.notification-preference.title', 'How To Change Push Notification Settings')}</H2>
      <Separator />
      <H3 size="H6">{t('invitations.notification-preference.chrome-edge.title', 'Google Chrome / Microsoft Edge')}</H3>
      <Paragraph>
        {t(
          'invitations.notification-preference.chrome-edge-instructions',
          'To the left of the web address, click the "Lock" icon. Find "Notifications" in the list and choose "Allow"'
        )}
      </Paragraph>
      <Separator />
      <H3 size="H6">{t('invitations.notification-preference.safari.title', 'Safari')}</H3>
      <Paragraph>
        {t(
          'invitations.notification-preference.safari-instructions',
          ' Click on &quot;Safari&quot; in the top-left corner of your screen. Choose &quot;Settings&quot; from the dropdown menu. Select &quot;Websites&quot;, then select &quot;Notifications&quot;.Select &quot;allow&quot; for the site &quot;www.familysearch.org&quot;.'
        )}
      </Paragraph>
      <Separator />
      <H3 size="H6">{t('invitations.notification-preference.firefox.title', 'FireFox')}</H3>
      <Paragraph>
        {t(
          'invitations.notification-preference.firefox-instructions',
          'To the left of the web address, click the &quot;Message Bubble/settings&quot; icon. Change permissions in the box that appears.'
        )}
      </Paragraph>
      <Separator size="xs" />
      <Link to="/identity/settings/notifications" external>
        {t(
          'invitations.notification-preference.change-other-notifications-action',
          'Change Other FamilySearch Notification Settings'
        )}
      </Link>
    </>
  )
}
